import { render, staticRenderFns } from "./dictionpopup.vue?vue&type=template&id=1920fdf2&scoped=true&"
import script from "./dictionpopup.vue?vue&type=script&lang=js&"
export * from "./dictionpopup.vue?vue&type=script&lang=js&"
import style0 from "./dictionpopup.vue?vue&type=style&index=0&id=1920fdf2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1920fdf2",
  null
  
)

export default component.exports